module.exports = __webpack_public_path__ + "nc_static/media/upto-date.dddbbca7.svg";